export enum AvailabilityDatePresentationEnum {
    percentage = 'PERCENTAGE',
    numberOfInjuries = 'NUMBER_OF_INJURIES'
}